const loader = () => ({
  v: '5.5.7',
  meta: {
    g: 'LottieFiles AE 0.1.21',
    a: '',
    k: '',
    d: '',
    tc: ''
  },
  fr: 30,
  ip: 0,
  op: 90,
  w: 500,
  h: 500,
  nm: 'actions',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Layer 7 Outlines 3',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [250, 250, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [150.25, 150.25, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [82.843, 0],
                    [0, -82.843],
                    [-82.843, 0],
                    [0, 82.843]
                  ],
                  o: [
                    [-82.843, 0],
                    [0, 82.843],
                    [82.843, 0],
                    [0, -82.843]
                  ],
                  v: [
                    [0, -150],
                    [-150, 0],
                    [0, 150],
                    [150, 0]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [150.25, 150.25],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'tm',
          s: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.667],
                  y: [1]
                },
                o: {
                  x: [0.333],
                  y: [0]
                },
                t: 60,
                s: [100]
              },
              {
                t: 90,
                s: [0]
              }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.667],
                  y: [1]
                },
                o: {
                  x: [0.333],
                  y: [0]
                },
                t: 70,
                s: [100]
              },
              {
                t: 90,
                s: [0]
              }
            ],
            ix: 2
          },
          o: {
            a: 0,
            k: 0,
            ix: 3
          },
          m: 1,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false
        },
        {
          ty: 'st',
          c: {
            a: 0,
            k: [0, 0.333333333333, 0.592156862745, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 30,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }
      ],
      ip: 60,
      op: 90,
      st: 60,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Layer 7 Outlines 2',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [250, 250, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [150.25, 150.25, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [82.843, 0],
                    [0, -82.843],
                    [-82.843, 0],
                    [0, 82.843]
                  ],
                  o: [
                    [-82.843, 0],
                    [0, 82.843],
                    [82.843, 0],
                    [0, -82.843]
                  ],
                  v: [
                    [0, -150],
                    [-150, 0],
                    [0, 150],
                    [150, 0]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [150.25, 150.25],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'tm',
          s: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.667],
                  y: [1]
                },
                o: {
                  x: [0.333],
                  y: [0]
                },
                t: 30,
                s: [100]
              },
              {
                t: 60,
                s: [0]
              }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.667],
                  y: [1]
                },
                o: {
                  x: [0.333],
                  y: [0]
                },
                t: 40,
                s: [100]
              },
              {
                t: 60,
                s: [0]
              }
            ],
            ix: 2
          },
          o: {
            a: 0,
            k: 0,
            ix: 3
          },
          m: 1,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false
        },
        {
          ty: 'st',
          c: {
            a: 0,
            k: [0, 0.333333333333, 0.592156862745, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 30,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }
      ],
      ip: 30,
      op: 60,
      st: 30,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Layer 7 Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [250, 250, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [150.25, 150.25, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [82.843, 0],
                    [0, -82.843],
                    [-82.843, 0],
                    [0, 82.843]
                  ],
                  o: [
                    [-82.843, 0],
                    [0, 82.843],
                    [82.843, 0],
                    [0, -82.843]
                  ],
                  v: [
                    [0, -150],
                    [-150, 0],
                    [0, 150],
                    [150, 0]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [150.25, 150.25],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Group 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'tm',
          s: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.667],
                  y: [1]
                },
                o: {
                  x: [0.333],
                  y: [0]
                },
                t: 0,
                s: [100]
              },
              {
                t: 30,
                s: [0]
              }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.667],
                  y: [1]
                },
                o: {
                  x: [0.333],
                  y: [0]
                },
                t: 10,
                s: [100]
              },
              {
                t: 30,
                s: [0]
              }
            ],
            ix: 2
          },
          o: {
            a: 0,
            k: 0,
            ix: 3
          },
          m: 1,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false
        },
        {
          ty: 'st',
          c: {
            a: 0,
            k: [0, 0.333333333333, 0.592156862745, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 30,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }
      ],
      ip: 0,
      op: 30,
      st: 0,
      bm: 0
    }
  ],
  markers: []
});

export default loader;
